export const PAGE_SIZE = 24;
/** The initial number of filter values to display */
export const FILTERS_INITIAL_LIMIT = 10;
/** The maximum number of filter values to display after clicking "show more".
 *  Set to 31 (one above the visible threshold) so CSS can detect when a list
 *  has > 30 items via :nth-child(31) to conditionally show the search box. */
export const FILTERS_MAX_LIMIT = 31;

/** Map of special offer slugs to their labels */
export const SPECIAL_OFFERS_MAP = {
  'clearance': 'Clearance',
  // 'coming-soon': 'Coming Soon',
  'featured': 'Featured',
  'hot-buy': 'Hot Buy',
  // 'new': 'New',
  // 'pre-order': 'Pre-Order',
  'sale': 'Sale',
  // 'special-promotion-applies': 'Special Promotion Applies',
};

/** Whitelist which special offers "featured" tags to show */
export const SPECIAL_OFFERS_WHITELIST = Object.values(SPECIAL_OFFERS_MAP);
export const SPECIAL_OFFERS_SLUG_REGEX = new RegExp(Object.keys(SPECIAL_OFFERS_MAP).join('|'));

// This is the full list of options that Dean posted:
// | name                       | slug                       | description                |
// | -------------------------- | -------------------------- | -------------------------- |
// | Available by Special Order | available-by-special-order | Available by Special Order |
// | Available for Raincheck    | available-for-raincheck    | Available for Raincheck    |
// | Clearance                  | clearance                  | Clearance                  |
// | Coming Soon                | coming-soon                | Coming Soon                |
// | Currently Out of Stock     | currently-out-of-stock     | Currently Out of Stock     |
// | Featured                   | featured                   | Featured                   |
// | Hot Buy                    | hot-buy                    | Hot Buy                    |
// | Login for Best Pricing     | login-for-best-pricing     | Login for Best Pricing     |
// | New                        | new                        | New                        |
// | New Model Available        | new-model-available        | New Model Available        |
// | No Longer Available        | no-longer-available        | No Longer Available        |
// | Pre-Order                  | pre-order                  | Pre-Order                  |
// | Sale                       | sale                       | Sale                       |
// | Special Promotion Applies  | special-promotion-applies  | Special Promotion Applies  |
